// Stub: will be replaced by real API calls
export const mockKYCSubmissions: any[] = [];
export const mockKYCStats = { total: 0, submitted: 0, underReview: 0, approved: 0, rejected: 0 };
